package org.hs_soft.runmynesto.domain.usecase.home

import org.hs_soft.runmynesto.domain.repository.local_datasource.home.SetNewCustomerRepository

class SetNewCustomerUseCase(
    private val repository: SetNewCustomerRepository
) {
    suspend operator fun invoke(newCustomer:Boolean) {
        return repository.setNewCustomer(newCustomer)
    }
}